import React, { useState, useEffect } from "react";
import axios from "axios";
import { Radio, Table, Input, DatePicker, Modal, Card, Row, Col, Space, Image, Checkbox, Button, message, Carousel } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { ExclamationCircleOutlined, PlusOutlined, EditOutlined, CloseCircleOutlined } from "@ant-design/icons";
import NewTable from "./components/NewTable";
import AdminEnvironmentModal from "./components/AdminEnvironmentModal";
import Carousel_news_ticker from "./components/Carousel_news_ticker";
const { RangePicker } = DatePicker;
const { confirm } = Modal;

const EnviornmentList = () => {
    const [total, set_total] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [search_date, set_search_date] = useState([])
    const [loading, set_loading] = useState(0)
    const [force_reload, set_force_reload] = useState(0)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [title, setTitle] = useState();
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [data, setData] = useState([]);
    const [datas, setDatas] = useState([])
    const [messageApi, contextHolder] = message.useMessage();
    const [default_column, set_default_column] = useState([
        {
            title: '照片',
            sorter: false,
            align: 'center',
            render: (text, record, index) => (<>
                <div
                    style={{
                        padding: 0,
                        margin: 'auto',
                        width: '150px',
                    }}
                >
                    <Carousel_news_ticker
                        file_url={record['file_url']}
                    />
                </div>
            </>)
        },
        {
            title: '設備',
            align: 'center',
            render: (text, record, index) => (
                <>
                </>
            )
        },
        {
            title: '管理員',
            key: 'user_name',
            dataIndex: 'user_name',
            align: 'center',
        },
        {
            title: '資訊',
            key: 'name',
            align: 'center',
            sorter: false,
            render: (text, record, index) => (
                <>
                    <Col >
                        <p style={{ fontSize: '24px', fontWeight: 400, }}>{record.name}</p>
                        <p style={{ fontSize: '18px', fontWeight: 400, }}>{record.name_serial}</p>
                        <p style={{ fontSize: '18px', fontWeight: 400, }}>容納人數：{record.capacity}人</p>
                        <p style={{ fontSize: '18px', fontWeight: 400, }}>介紹內文：{record.note}</p>
                    </Col>
                </>
            )
        },
        // {
        //     title: '形象網站',
        //     key: 'blog_id',
        //     align: 'center',
        //     render: (text, record, index) => (
        //         <>
        //             {/* <button type="button" className="btn btn-link text-success" onClick={e => handleOnShow(record)}>修改</button>
        //                 <button type="button" className="btn btn-link text-success" onClick={e => handleOnDelete(record.Pid)}>刪除</button> */}
        //             <Button type="primary" icon={<EditOutlined />}
        //             // onClick={e => handleOnEditRow(record)}
        //             >編輯</Button>
        //         </>
        //     )
        // },
        {
            title: '操作',
            sorter: false,
            align: 'center',
            render: (text, record, index) => (
                <>
                    <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => { setTitle('修改環境'); setEdit(true); setOpen(true); setColor('f09a45'); setEditCard(record) }}>編輯</Button>
                    <Button type="text" style={{ color: 'red' }} onClick={() => showMessage(record.surrounding_id)}>刪除</Button>
                </>
            )
        },
    ]);
    const getData = (param, sort, filter, checklist) => {
        set_loading(true);
        return axios
            .get('/cramSchool/api/surrounding', {
                params: {
                    cur_page: param?.current,
                    size: param?.pageSize,
                    custom_filter_key: checklist,
                    custom_filter_value: param?.keyword,
                    order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                },
                // paramsSerializer: function (params) {
                //     const NewParams = Object.entries(params).map(([map_key, map_value]) => {
                //         if (map_key === 'order') {
                //             return Object.entries(map_value).map(([map_value_key,map_value_value], i) => {
                //                 return `order[${i}][column]=${map_value_key}&order[${i}][type]=${map_value_value}`;
                //             })
                //         }else if (map_key === 'custom_filter_key') {
                //             return map_value.map(map_item=>`custom_filter_key[]=${map_item}`).join("&");
                //         }else{
                //             return `${map_key}=${map_value}`;
                //         }
                //     })
                //     return NewParams.join("&")
                // },
            })
            .then((response) => {
                set_total(response.data.total)
                setDatas(response.data.data);
                get_picture(response.data.data);
            })
            .finally(() => {
                set_loading(false)
            })
    }
    useEffect(() => {
        if (extra_columns === null) {
            get_table_setting();
        } else {
            set_table_setting()
        }
    }, [extra_columns])
    const set_table_setting = () => {
        axios
            .post('/cramSchool/api/custom_table_setting', [
                {
                    table_name: 'surrounding',
                    table_data: [
                        ...extra_columns.map(map_item => ({
                            column_key: map_item.key,
                            column_name: map_item.key
                        }))
                    ]
                }
            ])
    }
    const get_table_setting = () => {
        axios
            .get('/cramSchool/api/custom_table_setting', {
                params: {
                    custom_table_setting_table_name: 'surrounding'
                }
            })
            .then(response => {
                set_extra_columns(response.data.map(map_item => ({
                    title: map_item.column_key,
                    key: map_item.column_key,
                    dataIndex: map_item.column_key,
                })))
            })
    }
    useEffect(() => {
        getData();
    }, []);
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let surrounding_id = value['surrounding_id']
            if (value.file_id.length != 0 || value.file_id != null) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            setDatas(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (surrounding_id == value.surrounding_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })

    }
    const showMessage = (value) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                handleOnDelete(value);
            },
            centered: true
        });
    }
    const handleOnDelete = (value) => {
        axios
            .delete(`/cramSchool/api/surrounding`, {
                data: [{ surrounding_id: value }]
            })
            .then((response) => {
                if (response.data.status != undefined) {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        reload();

                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        reload();
                    }
                }
            })
    }
    const handleOnAddRow = () => {
        setTitle('新增環境');
        setColor('d65b77');
        setEdit(false);
        setOpen(true);
        setEditCard({});
    }
    const handleOnDeleteRow = () => {
        if (selectedRowKeys.length == 0) {
            messageApi.open({
                type: 'error',
                content: '請選擇資料',
            });
        } else {
            const deleterow = [];
            selectedRowKeys && selectedRowKeys.map((value) => {
                deleterow.push({ 'surrounding_id': value });
            })
            axios
                .delete(`/cramSchool/api/surrounding`, {
                    data: deleterow
                })
                .then((response) => {
                    // console.log(response)
                    if (response.data.status == 'success') {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        reload();
                    }
                })
        }
    }
    const handleEdit = (file_id) => {
        setOpen(false);
        axios
            .patch(`/cramSchool/api/surrounding`, [
                {
                    ...editcard,
                    file_id
                }
            ])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    reload();
                }
            })
        // console.log(editcard);
    }
    const handleSubmit = (file_id) => {
        if (JSON.stringify(editcard) == '{}') {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫任一欄位',
            });
        } else {
            axios
                .post(`/cramSchool/api/surrounding`, [
                    {
                        ...editcard,
                        file_id
                    }
                ])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '新增失敗',
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '新增成功',
                        });
                        reload();
                    }
                })
        }
    }
    useEffect(() => {
        data.forEach(each_item => {
            if (each_item.surrounding_id === editcard.surrounding_id) {
                setEditCard(prev => (
                    {
                        ...prev,
                        file_url: each_item.file_url
                    }
                ))
            }
        })
    }, [data])
    return (
        <>
            {contextHolder}
            <AdminEnvironmentModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                setData={setData}
                data={data}
                editcard={editcard}
                setEditCard={setEditCard}
                setOpen={setOpen}
                handleSubmit={handleSubmit}
                handleEdit={handleEdit}
            />
            <Col span={24} style={{ paddingTop: '10px' }}>
                <NewTable
                    total={total}
                    extra_columns={extra_columns}
                    set_extra_columns={set_extra_columns}
                    loading={loading}
                    page_name={'EnvironmentList'}
                    force_reload={force_reload}
                    columns={default_column.concat(extra_columns || [])}
                    getData={getData}
                    datas={datas}//table資料
                    add_button_title={'新增環境'}//新增按鈕上的名稱
                    handleOnAddRow={handleOnAddRow}//新增row 內容
                    rowkey={'surrounding_id'}//key
                    setSelectedRowKeys={setSelectedRowKeys}
                    searchdate={false}
                    selectedRowKeys={selectedRowKeys}
                    handleOnDeleteRow={handleOnDeleteRow}//多筆刪除

                ></NewTable>
            </Col>

        </>
    );
};

export default EnviornmentList;